import { BodyComponentConsts, ItemTableConsts } from 'client/util/Constants';
import { Types } from '@jumpcloud/ui-components';

import ApplicationShortenedText from 'client/components/ItemTable/BodyComponents/ApplicationShortenedText.vue';

const getAppItemTableColumnSettings = () => {
  const { application } = BodyComponentConsts.statusIconTypes;
  const { columnTypes } = ItemTableConsts;
  const statusIconType = application;

  const columns = {
    displayLabel: {
      bodyComponent: ApplicationShortenedText,
      bodyComponentProps: {
        field: 'displayLabel',
      },
      name: 'Display Label',
      headingText: 'Display Label',
      sortBy: 'displayLabel',
    },
    name: {
      bodyComponent: ApplicationShortenedText,
      bodyComponentProps: {
        field: 'name',
      },
      name: 'Name',
      sortBy: 'name',
    },
    status: {
      bodyComponent: 'StatusIcon',
      bodyComponentProps: {
        type: statusIconType,
      },
      classNames: {
        body: [columnTypes.statusColumn],
        heading: [columnTypes.statusColumn],
      },
      name: 'Status',
    },
  };

  Object.keys(columns).forEach((key) => {
    columns[key].headingText = columns[key].name;
  });

  return columns;
};

const { Column } = Types;

const appItemListPaginationColumns = [
  Column({
    dataFieldName: 'status',
    label: 'Status',
    width: '0.3fr',
  }),
  Column({
    dataFieldName: 'logo',
    label: 'Logo',
    width: '0.7fr',
  }),
  Column({
    dataFieldName: 'displayLabel',
    label: 'Display Label',
    sortable: true,
    width: '1fr',
  }),
  Column({
    dataFieldName: 'sso.hidden',
    label: 'Show in User Portal',
    sortable: true,
    width: '1fr',
  }),
  Column({
    dataFieldName: 'supportedFunctionality',
    label: 'Supported Functionality',
    width: '1.5fr',
  }),
  Column({
    dataFieldName: 'idpCertStatus',
    label: 'IdP Certificate Status',
    width: '1fr',
  }),
];

export {
  appItemListPaginationColumns,
  getAppItemTableColumnSettings,
};
